export const SIWC_AUTH_METHOD_TYPE = 'Sign in with Cosmos'
export const SIWC_AUTH_METHOD_ID_PREFIX = 'siwc'
